
(function () {
  function initProductTabs(scope) {
    var wraps = [];

    if (scope && scope.matches && scope.matches('.pts-wrap')) {
      wraps.push(scope);
    }

    if (scope && scope.querySelectorAll) {
      scope.querySelectorAll('.pts-wrap').forEach(function (wrap) {
        wraps.push(wrap);
      });
    }

    wraps.forEach(function (wrap) {
      if (wrap.dataset.ptsInitialized === 'true') return;
      wrap.dataset.ptsInitialized = 'true';

      var tabs = wrap.querySelectorAll('.pts-tab');
      var panels = wrap.querySelectorAll('.pts-panel');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = this.dataset.tab;

          tabs.forEach(function (item) {
            item.classList.remove('is-active');
            item.setAttribute('aria-selected', 'false');
            item.setAttribute('tabindex', '-1');
          });

          panels.forEach(function (panel) {
            panel.classList.remove('is-active');
            panel.hidden = true;
          });

          this.classList.add('is-active');
          this.setAttribute('aria-selected', 'true');
          this.setAttribute('tabindex', '0');

          var panel = Array.from(panels).find(function (item) {
            return item.id === 'panel-' + target;
          });

          if (panel) {
            panel.classList.add('is-active');
            panel.hidden = false;
          }
        });
      });

      // Keep the first panel visible on initialization.
      panels.forEach(function (panel, index) {
        var active = index === 0;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    });
  }

  function initAll() {
    initProductTabs(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductTabs(event.target);
  });
})();
